import { Resume } from '../models';

export const dummyResumeData: Resume[] = [
  {
    id: 1,
    date: '2022-04-18',
    location: 'Rumah Sakit Maju Jaya',
    diagnose: 'E11.9 - Diabetes mellitus',
    recordNumber: '12345',
    nik: '1234567890',
    patientType: 'Inpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Endocrinology',
    anamnesis: 'Patient presented with high blood sugar levels...',
    medicine: 'Insulin',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 2,
    date: '2022-04-04',
    location: 'Puskesmas Serpong',
    diagnose: 'E11.9 - Diabetes mellitus',
    recordNumber: '54321',
    nik: '0987654321',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Internal Medicine',
    anamnesis:
      'Patient complained of increased thirst and frequent urination...',
    medicine: 'Metformin',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 3,
    date: '2022-03-21',
    location: 'Klinik Makmur Jaya',
    diagnose: 'E11.9 - Diabetes mellitus',
    recordNumber: '98765',
    nik: '6789012345',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Family Medicine',
    anamnesis: 'Patient has a family history of diabetes...',
    medicine: 'Glipizide',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 4,
    date: '2022-03-07',
    location: 'Rumah Sakit Medika',
    diagnose: 'E11.9 - Diabetes mellitus',
    recordNumber: '56789',
    nik: '3456789012',
    patientType: 'Inpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Endocrinology',
    anamnesis: 'Patient admitted with diabetic ketoacidosis...',
    medicine: 'NovoLog',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 5,
    date: '2022-02-22',
    location: 'Puskesmas Serpong',
    diagnose: 'E11.9 - Diabetes mellitus',
    recordNumber: '23456',
    nik: '4567890123',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Internal Medicine',
    anamnesis: 'Patient needs a refill of her diabetes medication...',
    medicine: 'Acarbose',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 6,
    date: '2022-02-07',
    location: 'Rumah Sakit Maju Jaya',
    diagnose: 'A75 - Demam tifus',
    recordNumber: '67890',
    nik: '7890123456',
    patientType: 'Inpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Infectious Diseases',
    anamnesis: 'Patient presented with high fever and abdominal pain...',
    medicine: 'Typhoid vaccine',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 7,
    date: '2022-01-24',
    location: 'Puskesmas Serpong',
    diagnose: 'A75 - Demam tifus',
    recordNumber: '78901',
    nik: '8901234567',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Internal Medicine',
    anamnesis: 'Patient complained of fever, headache, and body aches...',
    medicine: 'Antibiotics',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 8,
    date: '2022-01-07',
    location: 'Klinik Makmur Jaya',
    diagnose: 'Z23.2 - Imunisasi BCG',
    recordNumber: '34567',
    nik: '5678901234',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Pediatrics',
    anamnesis: 'Patient brought in for routine BCG vaccination...',
    medicine: 'BCG vaccine',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 9,
    date: '2021-12-21',
    location: 'Klinik Angga Jaya',
    diagnose: 'Z23.2 - Vaksin BCG',
    recordNumber: '12312',
    nik: '5678901234',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Pediatrics',
    anamnesis: 'Patient brought in for routine BCG vaccination...',
    medicine: 'BCG vaccine',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
  {
    id: 10,
    date: '2021-12-10',
    location: 'Klinik Ari Jaya',
    diagnose: 'Z23.1 - Vaksin BCG',
    recordNumber: '111421',
    nik: '5678901234',
    patientType: 'Outpatient',
    patientName: 'Jimmy Daniel',
    doctorName: 'Dr. Ali',
    polyName: 'Pediatrics',
    anamnesis: 'Patient brought in for routine BCG vaccination...',
    medicine: 'BCG vaccine',
    checkUpImages: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaL9yfbVJa_66vRiSPS4-2s4slESd-dl1Wwg&usqp=CAU',
      'https://res.cloudinary.com/dk0z4ums3/image/upload/v1677730952/attached_image/tindakan-medis/radiologi/rontgen-kepala.jpg',
      'https://rskasihibu.com/wp-content/uploads/2018/05/mri-magnetom-verio-abdomen_t1_vibe_fs-00139022_8-654x654.jpg',
      'https://p1.pxfuel.com/preview/822/608/945/x-ray-health-arm-doctors.jpg',
    ],
  },
];
